module.exports = __webpack_public_path__ + "img/rectangle_icon.d8b079ed.svg";